import {
  listTickets as publicListTickets,
  getTicket as publicGetTicket,
  checkInTickets as publicCheckInTickets,
  deleteTicketCheckIns as publicDeleteTicketCheckIns,
  updateTicket as publicUpdateTicket,
  bulkUpdateTickets as publicBulkUpdateTickets,
} from './events-v1-ticket-tickets.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onTicketOrderUpdated as publicOnTicketOrderUpdated } from './events-v1-ticket-tickets.public.js';

export const listTickets: MaybeContext<
  BuildRESTFunction<typeof publicListTickets> & typeof publicListTickets
> = /*#__PURE__*/ createRESTModule(publicListTickets);
export const getTicket: MaybeContext<
  BuildRESTFunction<typeof publicGetTicket> & typeof publicGetTicket
> = /*#__PURE__*/ createRESTModule(publicGetTicket);
export const checkInTickets: MaybeContext<
  BuildRESTFunction<typeof publicCheckInTickets> & typeof publicCheckInTickets
> = /*#__PURE__*/ createRESTModule(publicCheckInTickets);
export const deleteTicketCheckIns: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTicketCheckIns> &
    typeof publicDeleteTicketCheckIns
> = /*#__PURE__*/ createRESTModule(publicDeleteTicketCheckIns);
export const updateTicket: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTicket> & typeof publicUpdateTicket
> = /*#__PURE__*/ createRESTModule(publicUpdateTicket);
export const bulkUpdateTickets: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateTickets> &
    typeof publicBulkUpdateTickets
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateTickets);
/** */
export const onTicketOrderUpdated: BuildEventDefinition<
  typeof publicOnTicketOrderUpdated
> &
  typeof publicOnTicketOrderUpdated = createEventModule(
  publicOnTicketOrderUpdated
);

export {
  OrderStatus,
  SubdivisionType,
  ChannelType,
  TicketFieldset,
  State,
  WebhookIdentityType,
} from './events-v1-ticket-tickets.universal.js';
export {
  TicketingTicket,
  Money,
  CheckIn,
  GuestDetails,
  FormResponse,
  InputValue,
  FormattedAddress,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  StandardDetails,
  FormSubmission,
  TicketDetails,
  ListTicketsRequest,
  ListTicketsResponse,
  FacetCounts,
  TicketFacets,
  TicketFacetCounts,
  Counts,
  GetTicketRequest,
  GetTicketResponse,
  CheckInTicketRequest,
  CheckInTicketResponse,
  OrderUpdated,
  Ticket,
  OnlineConferencingLogin,
  DeleteTicketCheckInRequest,
  DeleteTicketCheckInResponse,
  UpdateTicketRequest,
  GuestDetailsUpdate,
  UpdateTicketResponse,
  BulkUpdateTicketsRequest,
  BulkUpdateTicketsResponse,
  GetDemoTicketRequest,
  GetDemoTicketResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  TicketOrderUpdatedEnvelope,
  ListTicketsOptions,
  GetTicketOptions,
  CheckInTicketsOptions,
  DeleteTicketCheckInsOptions,
  UpdateTicketOptions,
  BulkUpdateTicketsOptions,
} from './events-v1-ticket-tickets.universal.js';
export {
  OrderStatusWithLiterals,
  SubdivisionTypeWithLiterals,
  ChannelTypeWithLiterals,
  TicketFieldsetWithLiterals,
  StateWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './events-v1-ticket-tickets.universal.js';
